module.exports = __webpack_public_path__ + "img/29.4af9f938.jpg";